import { render, staticRenderFns } from "./EditTemplateView.vue?vue&type=template&id=66294817"
import script from "./EditTemplateView.vue?vue&type=script&lang=js"
export * from "./EditTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports